import { render } from "./HBEVirtualCard.vue?vue&type=template&id=4f596aa7&scoped=true"
import script from "./HBEVirtualCard.vue?vue&type=script&lang=js"
export * from "./HBEVirtualCard.vue?vue&type=script&lang=js"

import "./HBEVirtualCard.vue?vue&type=style&index=0&id=4f596aa7&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f596aa7"]])

export default __exports__